import { render } from "./PartnerSectionThree.vue?vue&type=template&id=420be516"
import script from "./PartnerSectionThree.vue?vue&type=script&lang=js"
export * from "./PartnerSectionThree.vue?vue&type=script&lang=js"

import "./PartnerSectionThree.vue?vue&type=style&index=0&id=420be516&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__